export const defaultURL = "https://analytics.feelgroup.io/api/v1";
export const defaultStagingURL = "https://analytics-staging.feelgroup.io/api/v1";
